
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
// import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
// import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import classnames from 'classnames';
import Collapse from '@material-ui/core/Collapse';
import Highlighter from 'react-highlight-words';
import Avatar from '@material-ui/core/Avatar';
import CardHeader from '@material-ui/core/CardHeader';
import green from '@material-ui/core/colors/green';
import brown from '@material-ui/core/colors/brown';
import teal from '@material-ui/core/colors/teal';
import purple from '@material-ui/core/colors/purple';
import orange from '@material-ui/core/colors/orange';
import red from '@material-ui/core/colors/red';
import blue from '@material-ui/core/colors/blue';
import amber from '@material-ui/core/colors/amber'
import Button from '@material-ui/core/Button';


const styles = theme => ({
  card: {
    minWidth: 275,
    [theme.breakpoints.up('md')]: {
      marginLeft: 330,
    },
    marginBottom: 20,
    
  },
  avatar_red: {
    backgroundColor: red[700],
    width: 70,
    height: 70,
  },
  avatar_green: {
    backgroundColor: green[500],
    width: 70,
    height: 70,
  },
  avatar_blue: {
    backgroundColor: blue[500],
    width: 70,
    height: 70,
  },
  avatar_brown: {
    backgroundColor: brown[500],
    width: 70,
    height: 70,
  },
  avatar_orange: {
    backgroundColor: orange[500],
    width: 70,
    height: 70,
  },
  avatar_teal: {
    backgroundColor: teal[500],
    width: 70,
    height: 70,
  },
  avatar_purple: {
    backgroundColor: purple[500],
    width: 70,
    height: 70,
  },
  avatar_amber: {
    backgroundColor: amber[500],
    width: 70,
    height: 70,
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  author: {
    fontSize: 14,
  },
  actions: {
    display: 'flex',
    
  },
  expand: {
    transform: 'rotate(0deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
    marginLeft: 'auto',
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  expandDetails: {
    // marginLeft: 3,
    // marginBottom: 10,
    marginLeft: 'auto',
  },
  expandOpenDetails: {
    // visibility: 'hidden',
  },
  expandDetailsBottom: {
    // marginLeft: 3,
    // marginBottom: 10,
    marginLeft: 'auto',
    visibility: 'hidden',
  },
  expandOpenDetailsBottom: {
    visibility: 'visible',
  },
  title: {
    [theme.breakpoints.up('md')]: {
      fontSize: 18,
    },
    fontSize: 16,
  },
  subheading: {
    [theme.breakpoints.up('md')]: {
      fontSize: 16,
    },
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  drawer: {
      position: 'relative',
  },
  header: {
    paddingBottom: 0,
  },
  location: {
    fontStyle: 'italic',
  },
});

const gtag = window.gtag;

class SessionCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = { expanded: false };
  }

  handleExpandClick = () => {
    this.setState(state => ({ expanded: !state.expanded }));
    // if (!this.state.expanded) {
    //   if (typeof(gtag) === 'function') {
    //     gtag('event','show_detail',{ 'event_category':'more_detail','event_label': this.props.session.id });
    //   }
    // }
  };

  render() {
    const { classes, session, searchKeyword } = this.props;
    let searchtext = [];
    searchtext.push(searchKeyword);
    return (
      <div>
            <Card className={classes.card} key={session.id}>
            { session.tag.substring(0,2) === 'PO' && <CardHeader className={classes.header}
            avatar={
              <Avatar aria-label="Session Identifier" className={classes.avatar_blue}>
                {session.tag}
              </Avatar>
            }
            title={<Typography color="default" className={classes.title} variant="title">
              <Highlighter highlightClassName="YourHighlightClass"
                searchWords={searchtext}
                autoEscape={true} textToHighlight={session.title}/>
            </Typography>}
            subheader={ <div>
                          <Typography variant="subheading" className={classes.subheading}>
                          {session.authors.map((itemAuthor,itemAuthorKey) => {
                              if (itemAuthorKey < session.authors.length - 1)
                              return(
                                <Highlighter highlightClassName="YourHighlightClass"
                                  searchWords={searchtext}
                                  autoEscape={true} textToHighlight={`${itemAuthor.firstName} ${itemAuthor.lastName}${itemAuthor.credentials && ', '}${itemAuthor.credentials}; `}/>
                              );
                              else
                              return(
                                <Highlighter highlightClassName="YourHighlightClass"
                                  searchWords={searchtext}
                                  autoEscape={true} textToHighlight={`${itemAuthor.firstName} ${itemAuthor.lastName}${itemAuthor.credentials && ','} ${itemAuthor.credentials}`}/>
                              );
                            })}
                        </Typography>
                        <Typography color="textSecondary">
                        { session.handouts.length > 0 && session.handouts.map((handout,handoutKey) => { 
                          if (handoutKey < session.handouts.length - 1)
                            return (
                              <span><a target="_blank" rel="noopener noreferrer" href={handout}>Handout {handoutKey+1}</a>, </span>
                            )
                          else
                          return (
                            <a target="_blank" rel="noopener noreferrer" href={handout}>Handout {handoutKey+1}</a>
                          )
                        })}
                        </Typography>
                      </div>
            }
            /> }

            { session.tag.substring(0,2) === 'IW' && <CardHeader className={classes.header}
            avatar={
              <Avatar aria-label="Session Identifier" className={classes.avatar_red}>
                {session.tag}
              </Avatar>
            }
            title={<Typography color="default" className={classes.title} variant="title">
              <Highlighter highlightClassName="YourHighlightClass"
                searchWords={searchtext}
                autoEscape={true} textToHighlight={session.title}/>
            </Typography>}
            subheader={ <div>
                          <Typography variant="subheading" className={classes.subheading}>
                          {session.authors.map((itemAuthor,itemAuthorKey) => {
                              if (itemAuthorKey < session.authors.length - 1)
                              return(
                                <Highlighter highlightClassName="YourHighlightClass"
                                  searchWords={searchtext}
                                  autoEscape={true} textToHighlight={`${itemAuthor.firstName} ${itemAuthor.lastName}${itemAuthor.credentials && ', '}${itemAuthor.credentials}; `}/>
                              );
                              else
                              return(
                                <Highlighter highlightClassName="YourHighlightClass"
                                  searchWords={searchtext}
                                  autoEscape={true} textToHighlight={`${itemAuthor.firstName} ${itemAuthor.lastName}${itemAuthor.credentials && ','} ${itemAuthor.credentials}`}/>
                              );
                            })}
                        </Typography>
                        <Typography color="textSecondary">
                        { session.handouts.length > 0 && session.handouts.map((handout,handoutKey) => { 
                          if (handoutKey < session.handouts.length - 1)
                            return (
                              <span><a target="_blank" rel="noopener noreferrer" href={handout}>Handout {handoutKey+1}</a>, </span>
                            )
                          else
                          return (
                            <a target="_blank" rel="noopener noreferrer" href={handout}>Handout {handoutKey+1}</a>
                          )
                        })}
                        </Typography>
                      </div>
            }
            /> }

            { session.tag.substring(0,2) === 'PC' && <CardHeader className={classes.header}
            avatar={
              <Avatar aria-label="Session Identifier" className={classes.avatar_purple}>
                {session.tag}
              </Avatar>
            }
            title={<Typography color="default" className={classes.title} variant="title">
              <Highlighter highlightClassName="YourHighlightClass"
                searchWords={searchtext}
                autoEscape={true} textToHighlight={session.title}/>
            </Typography>}
            subheader={ <div>
                          <Typography variant="subheading" className={classes.subheading}>
                          {session.authors.map((itemAuthor,itemAuthorKey) => {
                              if (itemAuthorKey < session.authors.length - 1)
                              return(
                                <Highlighter highlightClassName="YourHighlightClass"
                                  searchWords={searchtext}
                                  autoEscape={true} textToHighlight={`${itemAuthor.firstName} ${itemAuthor.lastName}${itemAuthor.credentials && ', '}${itemAuthor.credentials}; `}/>
                              );
                              else
                              return(
                                <Highlighter highlightClassName="YourHighlightClass"
                                  searchWords={searchtext}
                                  autoEscape={true} textToHighlight={`${itemAuthor.firstName} ${itemAuthor.lastName}${itemAuthor.credentials && ','} ${itemAuthor.credentials}`}/>
                              );
                            })}
                        </Typography>
                        
                        <Typography color="textSecondary">
                        { session.handouts.length > 0 && session.handouts.map((handout,handoutKey) => { 
                          if (handoutKey < session.handouts.length - 1)
                            return (
                              <span><a target="_blank" rel="noopener noreferrer" href={handout}>Handout {handoutKey+1}</a>, </span>
                            )
                          else
                          return (
                            <a target="_blank" rel="noopener noreferrer" href={handout}>Handout {handoutKey+1}</a>
                          )
                        })}
                        </Typography>
                        </div>
            }
            /> }

            { session.tag.substring(0,2) === 'IC' && <CardHeader className={classes.header}
            avatar={
              <Avatar aria-label="Session Identifier" className={classes.avatar_green}>
                {session.tag}
              </Avatar>
            }
            title={<Typography color="default" className={classes.title} variant="title">
              <Highlighter highlightClassName="YourHighlightClass"
                searchWords={searchtext}
                autoEscape={true} textToHighlight={session.title}/>
            </Typography>}
            subheader={ <div>
                          <Typography variant="subheading" className={classes.subheading}>
                          {session.authors.map((itemAuthor,itemAuthorKey) => {
                              if (itemAuthorKey < session.authors.length - 1)
                              return(
                                <Highlighter highlightClassName="YourHighlightClass" key={session.tag+'-'+itemAuthorKey}
                                  searchWords={searchtext}
                                  autoEscape={true} textToHighlight={`${itemAuthor.firstName} ${itemAuthor.lastName}${itemAuthor.credentials && ', '}${itemAuthor.credentials}; `}/>
                              );
                              else
                              return(
                                <Highlighter highlightClassName="YourHighlightClass" key={session.tag+'-'+itemAuthorKey}
                                  searchWords={searchtext}
                                  autoEscape={true} textToHighlight={`${itemAuthor.firstName} ${itemAuthor.lastName}${itemAuthor.credentials && ','} ${itemAuthor.credentials}`}/>
                              );
                            })}
                          </Typography>
                          <Typography color="textSecondary" className={classes.location}>
                            {session.location}
                          </Typography>
                          <Typography color="textSecondary">
                          { session.handouts.length > 0 && session.handouts.map((handout,handoutKey) => { 
                            if (handoutKey < session.handouts.length - 1)
                              return (
                                <span><a target="_blank" rel="noopener noreferrer" href={handout}>Handout {handoutKey+1}</a>, </span>
                              )
                            else
                            return (
                              <a target="_blank" rel="noopener noreferrer" href={handout}>Handout {handoutKey+1}</a>
                            )
                          })}
                          </Typography>
                        </div>
            }
            /> }
            
            { session.tag.substring(0,2) === 'PS' && <CardHeader className={classes.header}
            avatar={
              <Avatar aria-label="Session Identifier" className={classes.avatar_brown}>
                {session.tag}
              </Avatar>
            }
            title={<Typography color="default" className={classes.title} variant="title">
              <Highlighter highlightClassName="YourHighlightClass"
                searchWords={searchtext}
                autoEscape={true} textToHighlight={session.title}/>
            </Typography>}
            subheader={ <div>
                          <Typography variant="subheading" className={classes.subheading}>
                          {session.authors.map((itemAuthor,itemAuthorKey) => {
                              if (itemAuthorKey < session.authors.length - 1)
                              return(
                                <Highlighter highlightClassName="YourHighlightClass" key={session.tag+'-'+itemAuthorKey}
                                  searchWords={searchtext}
                                  autoEscape={true} textToHighlight={`${itemAuthor.firstName} ${itemAuthor.lastName}${itemAuthor.credentials && ', '}${itemAuthor.credentials}; `}/>
                              );
                              else
                              return(
                                <Highlighter highlightClassName="YourHighlightClass" key={session.tag+'-'+itemAuthorKey}
                                  searchWords={searchtext}
                                  autoEscape={true} textToHighlight={`${itemAuthor.firstName} ${itemAuthor.lastName}${itemAuthor.credentials && ','} ${itemAuthor.credentials}`}/>
                              );
                            })}
                        </Typography>
                        <Typography color="textSecondary">
                        { session.handouts.length > 0 && session.handouts.map((handout,handoutKey) => { 
                          if (handoutKey < session.handouts.length - 1)
                            return (
                              <span><a target="_blank" rel="noopener noreferrer" href={handout}>Handout {handoutKey+1}</a>, </span>
                            )
                          else
                          return (
                            <a target="_blank" rel="noopener noreferrer" href={handout}>Handout {handoutKey+1}</a>
                          )
                        })}
                        </Typography>
                      </div>
            }
            /> }

            { session.tag.substring(0,2) === 'SS' && <CardHeader className={classes.header}
            avatar={
              <Avatar aria-label="Session Identifier" className={classes.avatar_teal}>
                {session.tag}
              </Avatar>
            }
            title={<Typography color="default" className={classes.title} variant="title">
              <Highlighter highlightClassName="YourHighlightClass"
                searchWords={searchtext}
                autoEscape={true} textToHighlight={session.title}/>
            </Typography>}
            subheader={ <div>
                          <Typography variant="subheading" className={classes.subheading}>
                          {session.authors.map((itemAuthor,itemAuthorKey) => {
                              if (itemAuthorKey < session.authors.length - 1)
                              return(
                                <Highlighter highlightClassName="YourHighlightClass"
                                  searchWords={searchtext}
                                  autoEscape={true} textToHighlight={`${itemAuthor.firstName} ${itemAuthor.lastName}${itemAuthor.credentials && ', '}${itemAuthor.credentials}; `}/>
                              );
                              else
                              return(
                                <Highlighter highlightClassName="YourHighlightClass" key={session.tag+'-'+itemAuthorKey}
                                  searchWords={searchtext}
                                  autoEscape={true} textToHighlight={`${itemAuthor.firstName} ${itemAuthor.lastName}${itemAuthor.credentials && ','} ${itemAuthor.credentials}`}/>
                              );
                            })}
                        </Typography>
                        <Typography color="textSecondary" className={classes.location}>
                          {session.location}
                        </Typography>
                        <Typography color="textSecondary">
                        { session.handouts.length > 0 && session.handouts.map((handout,handoutKey) => { 
                          if (handoutKey < session.handouts.length - 1)
                            return (
                              <span><a target="_blank" rel="noopener noreferrer" href={handout}>Handout {handoutKey+1}</a>, </span>
                            )
                          else
                          return (
                            <a target="_blank" rel="noopener noreferrer" href={handout}>Handout {handoutKey+1}</a>
                          )
                        })}
                        </Typography>
                      </div>
            }
            /> }

            { session.tag.substring(0,2) === 'SC' && <CardHeader className={classes.header}
            avatar={
              <Avatar aria-label="Session Identifier" className={classes.avatar_orange}>
                {session.tag}
              </Avatar>
            }
            title={<Typography color="default" className={classes.title} variant="title">
              <Highlighter highlightClassName="YourHighlightClass"
                searchWords={searchtext}
                autoEscape={true} textToHighlight={session.title}/>
            </Typography>}
            subheader={ <div>
                          <Typography variant="subheading" className={classes.subheading}>
                          {session.authors.map((itemAuthor,itemAuthorKey) => {
                              if (itemAuthorKey < session.authors.length - 1)
                              return(
                                <Highlighter highlightClassName="YourHighlightClass"
                                  searchWords={searchtext}
                                  autoEscape={true} textToHighlight={`${itemAuthor.firstName} ${itemAuthor.lastName}${itemAuthor.credentials && ', '}${itemAuthor.credentials}; `}/>
                              );
                              else
                              return(
                                <Highlighter highlightClassName="YourHighlightClass"
                                  searchWords={searchtext}
                                  autoEscape={true} textToHighlight={`${itemAuthor.firstName} ${itemAuthor.lastName}${itemAuthor.credentials && ','} ${itemAuthor.credentials}`}/>
                              );
                            })}
                        </Typography>
                        <Typography color="textSecondary" className={classes.location}>
                          {session.location}
                        </Typography>
                        <Typography color="textSecondary">
                        { session.handouts.length > 0 && session.handouts.map((handout,handoutKey) => { 
                          if (handoutKey < session.handouts.length - 1)
                            return (
                              <span><a target="_blank" rel="noopener noreferrer" href={handout}>Handout {handoutKey+1}</a>, </span>
                            )
                          else
                          return (
                            <a target="_blank" rel="noopener noreferrer" href={handout}>Handout {handoutKey+1}</a>
                          )
                        })}
                        </Typography>
                      </div>
            }
            /> }

            { session.tag.substring(0,2) === 'EV' && <CardHeader className={classes.header}
                                                                 avatar={
                                                                   <Avatar aria-label="Session Identifier" className={classes.avatar_amber}>
                                                                     {session.tag}
                                                                   </Avatar>
                                                                 }
                                                                 title={<Typography color="default" className={classes.title} variant="title">
                                                                   <Highlighter highlightClassName="YourHighlightClass"
                                                                                searchWords={searchtext}
                                                                                autoEscape={true} textToHighlight={session.title}/>
                                                                 </Typography>}
                                                                 subheader={ <div>
                                                                   <Typography variant="subheading" className={classes.subheading}>
                                                                     {session.authors.map((itemAuthor,itemAuthorKey) => {
                                                                       if (itemAuthorKey < session.authors.length - 1)
                                                                         return(
                                                                             <Highlighter highlightClassName="YourHighlightClass"
                                                                                          searchWords={searchtext}
                                                                                          autoEscape={true} textToHighlight={`${itemAuthor.firstName} ${itemAuthor.lastName}${itemAuthor.credentials && ', '}${itemAuthor.credentials}; `}/>
                                                                         );
                                                                       else
                                                                         return(
                                                                             <Highlighter highlightClassName="YourHighlightClass"
                                                                                          searchWords={searchtext}
                                                                                          autoEscape={true} textToHighlight={`${itemAuthor.firstName} ${itemAuthor.lastName}${itemAuthor.credentials && ','} ${itemAuthor.credentials}`}/>
                                                                         );
                                                                     })}
                                                                   </Typography>
                                                                   <Typography color="textSecondary">
                                                                     { session.handouts.length > 0 && session.handouts.map((handout,handoutKey) => {
                                                                       if (handoutKey < session.handouts.length - 1)
                                                                         return (
                                                                             <span><a target="_blank" rel="noopener noreferrer" href={handout}>Handout {handoutKey+1}</a>, </span>
                                                                         )
                                                                       else
                                                                         return (
                                                                             <a target="_blank" rel="noopener noreferrer" href={handout}>Handout {handoutKey+1}</a>
                                                                         )
                                                                     })}
                                                                   </Typography>
                                                                 </div>
                                                                 }
            /> }
            
            {/* <CardContent>
              <Typography paragraph variant="body2">
                  Presenters:
              </Typography>
              <Typography className={classes.author} color="textSecondary" variant="body2" >
                <ul>
                {session.authors.map((itemAuthor,itemAuthorKey) => {
                  
                  return(
                    <li key={itemAuthor.id+itemAuthorKey} color="textSecondary"><Highlighter highlightClassName="YourHighlightClass"
                      searchWords={searchtext}
                      autoEscape={true} textToHighlight={`${itemAuthor.firstName} ${itemAuthor.lastName}${itemAuthor.credentials && ','} ${itemAuthor.credentials}`}/></li>
                  );
                })}
                </ul>
              </Typography>
            </CardContent> */}
            <CardActions className={classes.actions} disableActionSpacing>
              <Button size="small" color="primary" onClick={this.handleExpandClick} className={classnames(classes.expandDetails, {
                  [classes.expandOpenDetails]: this.state.expanded,
                })}>
                {!this.state.expanded ? 'More Detail' : 'Less Detail'}
              </Button>
              {/* <IconButton
                className={classnames(classes.expand, {
                  [classes.expandOpen]: this.state.expanded,
                })}
                onClick={this.handleExpandClick}
                aria-expanded={this.state.expanded}
                aria-label="Show more"
              >
                <ExpandMoreIcon />
              </IconButton> */}
            </CardActions>
            <Collapse in={this.state.expanded} timeout="auto" unmountOnExit>
              <CardContent>
                <Typography paragraph variant="body2">
                  {session.description.length > 0 && 'Course Description:' }
                </Typography>
                <Typography className={classes.pos} color="textSecondary">
                  {session.description}
                </Typography>
                <Typography paragraph variant="body2">
                  {session.objectives.length > 0 && 'Learning Objectives:' }
                </Typography>
                <Typography className={classes.author} color="textSecondary"  component="h2">
                <ul>
                {session.objectives.map((objective,objectiveKey) => {
                  return(
                    <li key={objective.id+objectiveKey} color="primary">{objective.description}</li>
                  );
                })}
                </ul>
              </Typography>
              <Typography paragraph variant="body2">
                {session.authors.length > 0 && 'Presenters:' }
                </Typography>
              <Typography className={classes.author} color="textSecondary" component="h2">
                <ol>
                {session.authors.map((author,authorKey) => {
                  return(
                    <div key={author.id+authorKey}>
                      <Typography className={classes.author} color="textSecondary" variant="body2" component="h2">
                        {author.firstName} {author.lastName}{author.credentials && ','} {author.credentials}
                      </Typography>
                      {author.jobTitle1 != null && <Typography className={classes.author} color="textSecondary" variant="headline" component="h2">
                        {author.jobTitle1}
                      </Typography>}
                      {author.jobTitle2 != null && <Typography className={classes.author} color="textSecondary" variant="headline" component="h2">
                        {author.jobTitle2}
                      </Typography>}
                      {author.department != null && <Typography className={classes.author} color="textSecondary" variant="headline" component="h2">
                        {author.department}
                      </Typography>}
                      
                      <Typography className={classes.author} color="textSecondary" variant="headline" component="h2">
                        {author.affiliation}{(author.affiliation.length > 0 && author.country.length > 0) && ','} {author.country}
                      </Typography>
                      {/* { author.city && author.state && <Typography className={classes.author} color="textSecondary" variant="headline" component="h2">
                        {author.city}, {author.state}
                      </Typography> } */}
                      
                      {/* <Typography className={classes.author} color="textSecondary" variant="headline" component="h2">
                        {author.country}
                      </Typography> */}
                      <br />
                      <Typography className={classes.author} color="textSecondary" variant="headline" component="p">
                        {author.bio}
                      </Typography><br />
                      
                      
                    </div>
                  );
                })}
                </ol>
              </Typography>
              <Typography paragraph variant="body2">
                  {session.references.length > 0 && 'References:' }
                </Typography>
              <Typography className={classes.author} color="textSecondary" variant="headline" component="h2">
                <ol>
                {session.references.map((reference,referenceKey) => {
                  return(
                    <li key={reference.id+referenceKey} color="primary">{reference.description}</li>
                  );
                })}
                </ol>
              </Typography>
              </CardContent>
              
            </Collapse>
          </Card>
      </div>
    );
  }
}

SessionCard.propTypes = {
  classes: PropTypes.object.isRequired,
  session: PropTypes.object.isRequired,
  searchKeyword: PropTypes.string,
};

export default withStyles(styles)(SessionCard);